import { createSvgIcon } from '@mui/material';

export const ClockIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none">
    <path
      d="M8.94995 4V8.5L11.95 10M16.45 8.5C16.45 12.6421 13.0921 16 8.94995 16C4.80782 16 1.44995 12.6421 1.44995 8.5C1.44995 4.35786 4.80782 1 8.94995 1C13.0921 1 16.45 4.35786 16.45 8.5Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
  'Clock',
);
